<template>
  <div>
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 text-center"><span class="vertical-text">Search</span></div>
      <div class="col-2 text-center"><span class="vertical-text">Active</span></div>
    </div>
    <div class="row" v-for="(frame,idx) in frameTypeData" :key="idx">
      <div class="col-1">
        <label for="name">{{ (idx + 1) }}</label>
      </div>
      <div class="col-7">
        <div class="form-group">
          <input type="text" class="form-control discountLbl" :id="'name-' + idx" v-model="frame.name" @keyup="updateF()"/>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group">
          <input type="checkbox" class="form-control" :id="'name-' + idx" v-model="frame.search" @change="updateF()"/>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group">
          <input type="checkbox" class="form-control" :id="'name-' + idx" v-model="frame.active" @change="updateF()"/>
        </div>
      </div>
      <div class="col-12 mb-3">
        <div class="card card-body p-2 bg-light">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Subcategories</strong>
            <button class="btn btn-sm btn-outline-primary" :disabled="!frame.id" @click="addSubcategory(frame.id)">Add Subcategory</button>
          </div>
          <div v-if="!frame.id" class="text-muted small">
            Save the frame type first, then add subcategories.
          </div>
          <div class="row mb-2" v-for="sub in getSubcategoriesForFrame(frame.id)" :key="sub.local_key">
            <div class="col-6">
              <input
                type="text"
                class="form-control"
                v-model="sub.name"
                placeholder="Subcategory name"
              />
            </div>
            <div class="col-6 text-right">
              <button
                class="btn btn-sm btn-primary mr-2"
                :disabled="isSubcategorySaving(sub.local_key)"
                @click="saveSubcategory(sub)"
              >
                {{ isSubcategorySaving(sub.local_key) ? "Saving..." : "Save" }}
              </button>
              <button
                class="btn btn-sm btn-danger"
                :disabled="isSubcategoryDeleting(sub.local_key)"
                @click="deleteSubcategory(sub)"
              >
                {{ isSubcategoryDeleting(sub.local_key) ? "Deleting..." : "Delete" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-right">
        <button class="btn btn-primary" @click="addF">
          <span class="spinner-border spinner-border-sm spinAdd d-none" id="spinnerAddFrameType" role="status" aria-hidden="true"></span>
          Add
          </button>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import {useToast} from "vue-toastification";

export default {
  name: "FrameTypes",
  setup() {
    const toast = useToast();
    return {toast};
  },
  data() {
    return {
      subcategories: [],
      subcategorySavingMap: {},
      subcategoryDeletingMap: {}
    };
  },
  emits: {
    updateFrameType: null
  },
  computed: {
    ...mapGetters({
      'frameTypeData': 'product/getFrameTypeData',
      'subcategoryData': 'product/getSubcategoryData',
    }),

  },
  methods: {
    normalizeCollectionData(responseData) {
      if (Array.isArray(responseData)) {
        return responseData;
      }
      if (responseData && Array.isArray(responseData.data)) {
        return responseData.data;
      }
      if (responseData && responseData.data && Array.isArray(responseData.data.data)) {
        return responseData.data.data;
      }
      return Object.values(responseData || {});
    },
    async loadSubcategories() {
      const response = await this.$store.dispatch('product/setupSubcategory',{method:'get'});
      const normalized = this.normalizeCollectionData(response);
      this.subcategories = normalized
        .filter((item) => item && item.frame_type_id !== undefined)
        .map((item, index) => ({
          ...item,
          name: item.name || "",
          local_key: `existing-${item.id || index}`,
          isNew: false
        }));
    },
    addF() {
      document.querySelector('#spinnerAddFrameType').classList.remove('d-none');
      this.frameTypeData.push({name:'',search:false,active:false})
      this.$store.commit('product/setFrameType',this.frameTypeData);
      document.querySelector('#spinnerAddFrameType').classList.add('d-none');
    },
    updateF() {
      this.$emit('updateFrameType', this.frameTypeData)
    },
    addSubcategory(frameTypeId) {
      if (!frameTypeId) {
        return;
      }
      const key = `new-${frameTypeId}-${Date.now()}`;
      this.subcategories.push({
        id: null,
        frame_type_id: frameTypeId,
        name: "",
        isNew: true,
        local_key: key
      });
    },
    getSubcategoriesForFrame(frameTypeId) {
      if (!frameTypeId) {
        return [];
      }
      return this.subcategories.filter((subcategory) => String(subcategory.frame_type_id) === String(frameTypeId));
    },
    isSubcategorySaving(localKey) {
      return !!this.subcategorySavingMap[localKey];
    },
    isSubcategoryDeleting(localKey) {
      return !!this.subcategoryDeletingMap[localKey];
    },
    async saveSubcategory(subcategory) {
      if (!subcategory.name || !subcategory.name.trim()) {
        this.toast.error("Subcategory name is required");
        return;
      }
      this.subcategorySavingMap = {
        ...this.subcategorySavingMap,
        [subcategory.local_key]: true
      };
      try {
        const payload = {
          name: subcategory.name.trim(),
          frame_type_id: subcategory.frame_type_id
        };
        if (subcategory.isNew) {
          await this.$store.dispatch('product/setupSubcategory', {data: payload, method: 'post'});
        } else {
          await this.$store.dispatch('product/setupSubcategory', {data: {...payload, id: subcategory.id}, method: 'put'});
        }
        await this.loadSubcategories();
        this.toast.success("Subcategory saved");
      } catch (error) {
        this.toast.error("Unable to save subcategory");
      } finally {
        this.subcategorySavingMap = {
          ...this.subcategorySavingMap,
          [subcategory.local_key]: false
        };
      }
    },
    async deleteSubcategory(subcategory) {
      if (subcategory.isNew) {
        this.subcategories = this.subcategories.filter((item) => item.local_key !== subcategory.local_key);
        return;
      }
      this.subcategoryDeletingMap = {
        ...this.subcategoryDeletingMap,
        [subcategory.local_key]: true
      };
      try {
        await this.$store.dispatch('product/setupSubcategory', {data: {id: subcategory.id}, method: 'delete'});
        await this.loadSubcategories();
        this.toast.success("Subcategory deleted");
      } catch (error) {
        this.toast.error("Unable to delete subcategory");
      } finally {
        this.subcategoryDeletingMap = {
          ...this.subcategoryDeletingMap,
          [subcategory.local_key]: false
        };
      }
    }
  },
  async mounted() {

    //this.dataArr = this.frameTypeData
    await this.$store.dispatch('product/setupFrameType',{method:'get'})
    this.$emit('updateFrameType', this.frameTypeData)
    await this.loadSubcategories();
  }
};
</script>
<style scoped>

.spinDel{
  position: absolute;
  left:35px;
  top:10px;
}

.spinAdd{
  position: absolute;
  top:10px;
}

.vertical-text {
  /*
  writing-mode: vertical-rl;
  text-orientation: upright;
  */

}

</style>